<template>

    <div class="pimBrands">

        <!-- page-heading -->
        <page-heading pageTitle="SAM-ASSET_GROUPS-HEADER"></page-heading>

        <div class="columns">

            <div class="col-main">
                <v-client-table ref="sanovaAssetGroupsTable" name="tblSanovaAssetGroups" class="pimBrandsTable" :data="groups" :columns="table.tblColumns" :options="table.tblOptions">
                    

                    <!-- before table: FILTER OPTIONS -->
                    <template slot="beforeTable">

                        <div class="boxA" style="display: flex; gap: 5px;">

                            <!-- SUCHE -->
                            <div style="flex: 1;">
                                <div class="control has-icon search" style="max-width: 300px; min-width: 150px;">
                                    <input class="input" type="text" v-model.trim="searchTerm" placeholder="Suchbegriff">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </div>
                            </div>

                            <!-- Kategorie -->
                            <div style="flex: 0;">
                                <form-input
                                    inputType="select"
                                    :showLabel="false"
                                    label="SDP-SELECT_SANOVA_CATEGORY"
                                    v-model="selectedCategory"
                                    selectFieldName="name"
                                    :selectIsSearchable="true"
                                    :selectAllowEmpty="true"
                                    :selectOptions="sanovaCategories"
                                    :showLabelInOptions="false"
                                    selectOpenDirection="bottom">
                                </form-input>
                            </div>

                            <!-- Reset Filter -->
                            <div style="flex: 0;">
                                <span :class="['button reset-filter', isFilterActive ? 'is-blue' : 'is-disabled']" @click="resetFilters()">
                                    <span class="icon is-small">
                                        <i class="icon-ak-reset"></i>
                                    </span>
                                </span>
                            </div>

                        </div>  

                    </template>

                    <!-- loading indicator -->
                    <template v-if="isLoadingTableData" slot="afterBody">

                        <div class="overlay-loader"></div>
                        <loading-indicator size="36px"></loading-indicator>
                        
                    </template>

                    <!-- asset image -->
                    <template slot="asset" slot-scope="props">
                        <div v-if="props.row.asset">
                            <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImagePath(props.row.asset, true)"></div>
                        </div>
                        <div v-else class="imgWrapper placeholder-asset" style="display: flex; align-items: center; justify-content: center; background: #fafafa; border: 1px solid #efefef; border-radius: 2px;">
                            <i class="fa fa-picture-o" style="color: #ccc; font-size: 18px;"></i>
                        </div>
                    </template>

                    <!-- name -->
                    <template slot="name" slot-scope="props">

                        {{ props.row.name }}
              
                    </template>

                    <!-- groups -->
                    <template slot="groups" slot-scope="props">
                        <span v-if="props.row.sanovaCategory">
                            {{ props.row.sanovaCategory.name || props.row.sanovaCategory }}
                        </span>
                        <span v-else class="no-groups">—</span>
                    </template>

                    <!-- actions -->
                    <template slot="actions" slot-scope="props">
                        <div style="display: flex; gap: 8px;">
                            <span class="icon is-small has-pointer" @click.stop="openGroupsModal(props.row)" title="Bearbeiten">
                                <i class="icon-ak-bearbeiten"></i>
                            </span>
                            
                            <pop-confirm 
                                class="icon is-small has-pointer" 
                                content="Sind Sie sicher, dass Sie diese Gruppe löschen möchten?" 
                                icon="question-circle-o" 
                                :on-ok="function() { deleteGroup(props.row) }" 
                                ok-text="Löschen" 
                                cancel-text="Abbrechen" 
                                title="Gruppe löschen">
                                <i class="icon-ak-entfernen"></i>
                            </pop-confirm>
                        </div>
                    </template>

                </v-client-table>

            </div>

            <div class="col-aside">
                <div class="boxA">
                    <custom-button icon="icon-ak-hinzufuegen" name="SAM-BUTTON_ADD_GROUP" type="blue" @click.native="openGroupsModal(null)"> 
                    </custom-button>
                </div>
            </div>

        </div>  

        <!-- Asset Groups Modal -->
        <asset-groups-modal
            :is-show="groupsModal.show"
            :group="groupsModal.group"
            @close="closeGroupsModal"
            @saved="onGroupsSaved">
        </asset-groups-modal>

    </div>        
</template>

<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');
import AssetGroupsModal from './AssetGroupsModal.vue';


export default {
    name: 'sanovaAssetGroups',

    components: {
        AssetGroupsModal
    },
    data() {
        return {
            
            searchTerm: null,
            selectedCategory: null,
            isLoadingTableData: false,
            groups: [],
            sanovaCategories: [],

            groupsModal: {
                show: false,
                group: null
            },

            table: {

                tblColumns: ['asset', 'name', 'groups', 'actions'],

                tblOptions: {
                    saveState: true,
                    perPage: 15,

                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    headings: {
                        asset() {
                            return "Bild";
                        },
                        name() {
                            return "Gruppe";
                        },
                        groups() {
                            return 'Kategorie';
                        },
                        actions() {
                            return "";
                        },
                    },
                    sortable: ['name'],
                    filterable: false,
                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
                        loading: 'Lade Daten ...'
                    },
                    pagination: {
                        dropdown: false,
                        chunk: 5,
                        edge: false
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    columnsClasses: {
                        'asset': 'asset',
                        'name': 'name',
                        'groups': 'groups',
                        'actions': 'actions'
                    },

                    customFilters: [
                        {
                            name: 'search',
                            callback(row, string) {
                                if (string == null || string == "") {
                                    return true;
                                }
                                string = string.toLowerCase();
                                return row.name != null && row.name.toLowerCase().indexOf(string) > -1;
                            }
                        },
                        {
                            name: 'category',
                            callback(row, category) {
                                if (category == null || category === "") {
                                    return true;
                                }
                                let catId = category.id || category;
                                let rowCatId = row.sanovaCategory ? (row.sanovaCategory.id || row.sanovaCategory) : null;
                                return rowCatId == catId;
                            }
                        }
                    ]

                }
            },


        }
    },


    methods: {

        async load() {
            this.isLoadingTableData = true;
            try {
                const res = await this.axios.get(this.$config.api + 'sanovaAssetGroup?include=sanovaAssetGroup.asset,sanovaAssetGroup.sanovaCategory');
                let items = [];
                if (res && res.data) {
                    if (res.data.sanovaAssetGroup) {
                        items = res.data.sanovaAssetGroup.items || res.data.sanovaAssetGroup;
                    } else if (Array.isArray(res.data)) {
                        items = res.data;
                    }
                }
                this.groups = Array.isArray(items) ? items : [];
            }
            catch(err) {
                console.error('Error loading sanovaAssetGroup', err);
                this.groups = [];
            }
            finally {
                this.isLoadingTableData = false;
            }
        },
        
        getSanovaCategories() {
            this.axios.get(this.$config.api + 'sanovaCategory')
                .then(response => {
                    const categories = response.data.sanovaCategory || [];
                    this.sanovaCategories = categories.sort((a, b) => a.name.localeCompare(b.name));
                })
                .catch(e => {
                    console.error('Error loading categories:', e);
                });
        },

        resetFilters() {
            this.searchTerm = null;
            this.selectedCategory = null;
        },

        openGroupsModal(group) {
            this.groupsModal.group = group;
            this.groupsModal.show = true;
        },

        closeGroupsModal() {
            this.groupsModal.show = false;
            this.groupsModal.group = null;
        },

        onGroupsSaved() {
            this.load();
        },

        deleteGroup(row) {
            this.axios.delete(this.$config.api + 'sanovaAssetGroup/' + row.id)
                .then(() => {
                    this.$notify.open({
                        content: 'Gruppe erfolgreich gelöscht',
                        type: 'success'
                    });
                    this.load();
                })
                .catch(err => {
                    console.error('Error deleting group', err);
                    this.$notify.open({
                        content: 'Fehler beim Löschen der Gruppe',
                        type: 'danger'
                    });
                });
        },

        getImagePath(asset, thumb=false) {
            if(!asset) {
                return "";
            }
            let path = asset.path ? asset.path : 'dam/sanovaAssetGroup';
            return this.$config.cdnHost + "apokat-backend/assets/" + path + "/" + (thumb != false ? '150/' : '') + asset.filename;
        },

    },


    created() {
        this.load();
        this.getSanovaCategories();
    },

    computed: {
        isFilterActive() {
            return (this.searchTerm && this.searchTerm.trim() !== '') || (this.selectedCategory !== null && this.selectedCategory !== '');
        }
    },

    watch: {
        searchTerm(val) {
            Event.$emit('vue-tables.tblSanovaAssetGroups.filter::search', val);
        },
        selectedCategory(val) {
            Event.$emit('vue-tables.tblSanovaAssetGroups.filter::category', val);
        }
    },

}
</script>

<style lang="scss" scoped>


.pimBrandsTable {
  ::v-deep > .columns:first-child {
    display: none !important;
  }

  ::v-deep .VueTables__table {
    position: relative !important;
  }

  .overlay-loader {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    opacity: 0.65;
  }

  ::v-deep .v-spinner {
    position: absolute !important;
    z-index: 999;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }

  ::v-deep .table {
    #VueTables_th--asset {
      width: 100px;
    }
    #VueTables_th--actions {
      max-width: 50px;
      width: 50px;
    }
    #VueTables_th--groups {

    }
    td {
        vertical-align: middle;
        cursor: default !important;
        padding-top: 8px;
        padding-bottom: 8px;

        &.asset {
            width: 100px;
            .imgWrapper {
                background-repeat: no-repeat;
                background-position: 50% 50% !important;
    
                background-size: cover;
                width: 65px;
                height: 45px;
                margin: 0;
                background-color: #FFF;
                border: 1px solid #efefef;
                border-radius: 2px;
            }

            .imgWrapper[lazy=loading] {
                background-size: 30% !important;
            }
        }

        &.actions {
            width: 80px;
            max-width: 80px;
            .icon {
                cursor: pointer !important;
            }
        }

        &.groups {
            width: 200px;
            max-width: 200px;
            .groups-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 3px;
            }
            .group-tag {
                background: #eaf0fb;
                color: #3273dc;
                border: 1px solid #c5d9f7;
            }
            .no-groups {
                color: #ccc;
            }
        }
    }
  }

  ::v-deep .edit-groups-btn {
    color: #999;
    transition: color .2s;

    &:hover {
      color: #3273dc;
    }
  }


}
</style>
